import { type DocBlock, type DocBlockClass } from './_Doc.ts'

export class ParseError extends Error {}

export const TITLE = 'TITLE' as const
export const HEADING_1 = 'HEADING_1' as const
export const HEADING_2 = 'HEADING_2' as const
export const NORMAL_TEXT = 'NORMAL_TEXT' as const

export class TokenStream {
	private _it: IterableIterator<DocBlock>
	current?: DocBlock

	constructor(
		it: IterableIterator<DocBlock>
	) {
		this._it = it
		this._next()
	}

	private _next() {
		this.current = this._it.next().value
	}

	match(prefix: DocBlockClass, text: string) {
		if (!(this.current?.class === prefix && this.current?.text === text)) {
			throw new ParseError()
		}
		this._next()
	}

	tryMatch(prefix: DocBlockClass, text: string) {
		if (!(this.current?.class === prefix && this.current?.text === text)) {
			return undefined
		}
		this._next()
		return true
	}

	matchClass(prefix: DocBlockClass) {
		if (!(this.current?.class === prefix)) {
			throw new ParseError()
		}
		const content = this.current.text
		this._next()
		return content
	}

	tryMatchClass(prefix: DocBlockClass) {
		if (!(this.current?.class === prefix)) {
			return undefined
		}
		const content = this.current.text
		this._next()
		return content
	}

	consumePlainContent() {
		const content = []
		let line
		while (line = this.tryMatchClass(NORMAL_TEXT)) {
			content.push(line)
		}
		return content.join('\n')
	}
}
